
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getStyleList, getStyleInfo, copyStyle } from '@/api/Allservices'
// @ts-ignore
import bookImage from '@/assets/book.jpg'

@Component({
  components: {},
})
export default class FbdStyleLibrary extends Vue {
  @Prop({ default: () => ({}), required: true })
  templateList!: any

  @Prop({ default: 9999, required: true })
  orgId!: number
  visible = false
  loading = false
  CurrConfig: any = null
  bookImage = bookImage
  conditions = {
    limit: 8,
    skip: 0,
    customer_id: 0,
  }
  styleList = []
  count = 0
  page = 1
  types: any = {}
  size: any = {}
  listKeyword = this.$route.query.search || ''

  $refs!: {
    img: any
  }

  get org() {
    return this.$store.state.user?.orgs[0]?.orgId || 0
  }

  get fileType() {
    return this.$route.query.fileType
  }

  get selectedType() {
    const { type, fileType } = this.$route.query
    const key = Object.keys(this.types).find(k => this.types[k] === type)
    return fileType || key || '全部'
  }

  get selectedSize() {
    const { size } = this.$route.query
    const key = Object.keys(this.size).find(k => this.size[k] === size)
    return key || '全部'
  }

  get wordToFbdTypes() {
    return (this.$store.state.user?.orgs[0]?.wordToFbdTypes || '').split(',')
  }

  get list() {
    if (!this.listKeyword) {
      return this.templateList
    } else {
      return this.templateList.filter((v: any) => v.name.includes(this.listKeyword))
    }
  }

  async mounted() {
    await this.getStyleInfo()
    this.conditions.customer_id = this.org
  }

  // @Watch('$route.query.update_list', { deep: true })
  @Watch('conditions', { deep: true })
  async getList() {
    this.loading = true
    try {
      const { size, search } = this.$route.query
      const res = await getStyleList({
        type: this.types[this.selectedType as string] || 'all',
        size: size || 'all',
        search,
        ...this.conditions,
      })
      this.styleList = res.data
      this.count = res.count
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  }

  handleType(command: string) {
    const { type } = this.$route.query
    if (type !== command) {
      this.$router.replace({ query: { ...this.$route.query, type: command } })
      this.getList()
    }
  }

  handleSize(command: string) {
    const { size } = this.$route.query
    if (size !== command) {
      this.$router.replace({ query: { ...this.$route.query, size: command } })
      this.getList()
    }
  }

  async getStyleInfo() {
    const { type, size } = await getStyleInfo({})
    const types: any = {}
    if (this.wordToFbdTypes.length) {
      this.wordToFbdTypes.forEach((item: string) => {
        const keys = Object.keys(type)
        const values = Object.values(type)
        if (values.includes(item)) {
          types[keys[values.findIndex(v => v === item)]] = item
        }
      })
      this.types = { 全部: 'all', ...types }
    } else {
      this.types = { 全部: 'all', ...type }
    }
    this.size = size
  }

  searchList(val: string) {}

  async creatStyle(id?: number) {
    if (id) {
      this.$router.push({
        path: '/style-demo',
        query: {
          ...this.$route.query,
          style_id: id + '',
        },
      })
    } else {
      this.$router.push({
        path: '/style-demo',
        query: {
          ...this.$route.query,
        },
      })
    }
  }

  previewImg(index: number | string) {
    this.$refs.img[Number(index)].showViewer = true
  }

  handleStyle(id: number) {
    this.$emit('handleStyle', id)
    this.$emit('close')
  }

  async CopyStyle(_id: string) {
    await copyStyle({
      _id,
    })
    this.$message.success('复制成功')
    this.getList()
  }
}
